import Vue from "vue";
import "vant/lib/index.css";
import {
  Button,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Lazyload,
  Col,
  Row,
  Icon,
  Overlay,
  Tab,
  Tabs,
  List,
  Popup,
  Dialog,
  Toast,
} from "vant";

Vue.use(Button)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(Col)
  .use(Row)
  .use(Icon)
  .use(Overlay)
  .use(Tab)
  .use(List)
  .use(Tabs)
  .use(Dialog)
  .use(Popup);
